const authPaths = {
    login: () => `/login`,
    signup: () => `/signup`,
    forgotPassword: () => `/forgot-password`,
    changePassword: () => `/change-password`,
  };
  
  export default authPaths;
  